import { Picture } from "../../../Components/SantaCamApp/PhotoViewer/SantaPhotoInterfaces";
import SantaCam1 from "./WhiteHouseSantaCamAssets/SantaCam-01.webp";
import SantaCam2 from "./WhiteHouseSantaCamAssets/SantaCam-02.webp";
import SantaCam3 from "./WhiteHouseSantaCamAssets/SantaCam-03.webp";
import SantaCam4 from "./WhiteHouseSantaCamAssets/SantaCam-04.webp";
import SantaCam5 from "./WhiteHouseSantaCamAssets/SantaCam-05.webp";

export const SantaCamContent: Picture[] = [
  {
    image: SantaCam1,
    date: "Sunday 4 December 2022",
    time: "6:46:41 AM",
    location: "",
  },
  {
    image: SantaCam2,
    date: "Monday 5 December 2022",
    time: "9:46:45 AM",
    location: "",
  },
  {
    image: SantaCam3,
    date: "Tuesday 6 December 2022",
    time: "3:22:19 PM",
    location: "",
  },
  {
    image: SantaCam4,
    date: "Wednesday 7 December 2022",
    time: "5:36:25 PM",
    location: "",
  },
  {
    image: SantaCam5,
    date: "Thursday 8 December 2022",
    time: "4:32:21 PM",
    location: "",
  },
];
